@if (activeSectionRoute$ | async) {}
@if (routerEvents$ | async) {}

<div class="st-mobile-left-menu">
  <div class="st-mobile-left-menu-top-section">
    <img
      class="menu-logo"
      src="assets/images/HeaderAdroitLogo.svg"
      alt=""
    />
    <div class="st-mobile-left-menu-top-section-navigators">
      @if (homeButton().routeUrl.length) {
        <a
          [title]="homeButton().title"
          (click)="goToHome(homeButton().routeUrl)"
          [ngClass]="{ active: isStaticButtonActive() === 'home' }"
          class="body-medium-bold"
        >
          <em [class]="homeButton().iconClass"></em>
          <span>Home</span>
        </a>
      }
      @for (nav of navigationList(); track $index) {
        <a
          (click)="selectSection(nav)"
          [ngClass]="{ active: (activeSectionRoute$ | async)?.id === nav.id }"
          class="body-medium-bold"
        >
          <em [class]="nav.iconClass"></em>
          <span>{{ nav.name }}</span>
          @if (nav.children.length) {
            <em class="icon-caret-right ml-auto"></em>
          }
        </a>
      }
      @if (tools().length) {
        <a
          (click)="openTools()"
          class="body-medium-bold"
        >
          <em class="icon-circles-four"></em>
          <span>Apps</span>
          <em class="icon-caret-right ml-auto"></em>
        </a>
      }
    </div>
  </div>
  <div class="st-mobile-left-menu-bottom-section">
    <a
      class="profile-btn cursor-pointer"
      (click)="toggleMenu($event, profileMenue)"
      [ngClass]="{ active: isStaticButtonActive() === 'profile' }"
    >
      <img
        [src]="profile().profileImg"
        alt=""
      />
      <span class="body-medium-bold">{{ this.userName() }}</span>

      <p-menu
        #profileMenue
        [model]="dropDownItems"
        [popup]="true"
        appendTo="body"
      />
    </a>
  </div>
</div>
